import {
  loadPlan,
  normalizePlan,
  savePlan,
  type PracticePlan,
} from "./practice-storage";
import { getWorkspaceKey } from "./cloud-drill-storage";

const API = "/api/coach-practice-plans";

const headers = () => ({
  "Content-Type": "application/json",
  "X-Coach-Workspace-Key": getWorkspaceKey(),
});

export async function syncPracticePlan() {
  const local = loadPlan();
  try {
    const response = await fetch(API, { headers: headers() });
    if (!response.ok) throw new Error(`Cloud load returned ${response.status}`);
    const body = (await response.json()) as { plans?: PracticePlan[] };
    const remote = Array.isArray(body.plans)
      ? body.plans.map(normalizePlan)
      : [];
    const latest = remote.reduce(
      (current, plan) => (plan.updatedAt > current.updatedAt ? plan : current),
      local,
    );
    savePlan(latest);
    await saveCloudPracticePlan(latest);
    return { plan: latest, synced: true };
  } catch {
    return { plan: local, synced: false };
  }
}

export async function saveCloudPracticePlan(plan: PracticePlan) {
  try {
    const response = await fetch(API, {
      method: "POST",
      headers: headers(),
      body: JSON.stringify({ plans: [plan] }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
